// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__RDYLe","list_wrapper":"list_wrapper__ZdUwn","legendOuterWrapper":"legendOuterWrapper__wuGF7","legendInnerWrapper":"legendInnerWrapper__7mLNu","contributionWrapper":"contributionWrapper__21hLB","wrapperItem":"wrapperItem__1esnl","DonorContribution":"DonorContribution___fMHw","allDonorContribution":"allDonorContribution__3SAwD","contributionText":"contributionText__1BrzX"};


//////////////////
// WEBPACK FOOTER
// ./components/projectDonutBarChart/donutBarChart/components/groupedBarChart/style.scss
// module id = ai+R
// module chunks = 0 2